export default {
  details: null,
  detailsLoading: false,
};
